/**
 * By default, Remix will handle hydrating your app on the client for you.
 * You are free to delete this file if you'd like to, but if you ever want it revealed again, you can run `npx remix reveal` ✨
 * For more information, see https://remix.run/file-conventions/entry.client
 */

import { RemixBrowser } from "@remix-run/react";
import { startTransition, StrictMode } from "react";
import { hydrateRoot } from "react-dom/client";

import { initAnalytics } from "~/analytics/client";

// Start loading Mixpanel before hydration so it is ready for early interactions.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const token = (window as any).process?.env?.MIXPANEL_TOKEN as string | undefined;
if (token) {
  initAnalytics(token).catch(() => {}); // never block hydration
}

startTransition(() => {
  hydrateRoot(
    document,
    <StrictMode>
      <RemixBrowser />
    </StrictMode>,
  );
});
